export default {
    setLabels(state, labels) {
        state.labels[this.$i18n.locale] = labels
    }
}